import React from 'react';
import { useSelector } from 'react-redux';
import { languageSwitch } from '../../dictionary/translateFunctions.js';
import { conProyectos, conProyectosImg, conCategorias } from '../../conexiones/varConexiones.js';
import {fetchData} from '../../fetch/fetchData.js'
import './proyecto.css';
import { useState,useEffect } from 'react';

const apiData = fetchData(conProyectos);
const apiData2 = fetchData(conCategorias);

const Proyecto = (props) => {
    const [imgind, setIndex] = useState(0);
    const lang = useSelector((state) => state.lang.lang);
    const data = apiData.read();
    // Proyecto actual
    const proyecto = data?.listaproyectos.find((p) => p.id === props.id);
    const images_ = proyecto?.images ? proyecto.images.split(',') : [];

    // Construcción segura de la ruta
    const safeImage = (images_?.[imgind] || "").replace(/ /g, "%20");

    // Ruta como string
    const imageUrl = proyecto && images_[imgind] ? `${conProyectosImg}/${props.id}/${safeImage}`: null;

    // Rotación de imágenes
    useEffect(() => {
        if (!images_ || images_.length === 0) return;
        const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % images_.length);
        }, 8000);
        return () => clearInterval(interval);
    }, [images_]);

    // Si no hay datos aún, no renderizar nada
    if (!proyecto) {
        return null;
    }


    return(
        <>
            {data?.listaproyectos.map(
                (proyecto,index)=>{

                    if(proyecto.id === props.id){return<>
                    {/* <div className="img" style={{backgroundImage:imageUrl ? `url("${imageUrl}")` : "none"}}></div> */}
                    <div className='modal-contenedor-img'>
                    {images_?.map(
                        (imagen, index) => 
                        <div className="img" style={{backgroundImage:imageUrl ? `url("${conProyectosImg}/${props.id}/${imagen}")` : "none",zIndex:`${index}`,opacity:imgind===index?'100':'0'}}></div>
                    )}
                    </div>
                    <div key={`render_${proyecto.id}`} id={`render_${proyecto.id}`} className='contenedor_text'>
                        <div className='contenedor-textos'>
                            <h3>{languageSwitch(proyecto.name,lang)}</h3>
                            <span className='contenedor_info'>
                                <p>{proyecto.name !== '' ? proyecto.canales: ''}</p> 
                                <p>{proyecto.cliente !== '' ? proyecto.cliente : ''}</p>
                            </span>
                        </div>
                    <div className='contenedor_descripcion'>{
                        (() => {
                            const m = new RegExp(/\. /g);
                            const text = languageSwitch(proyecto.description,lang)

                            const elem = text.replace(m, ".<br /> ")
                            const arr = elem.split('<br />');
                            return arr.map((pr, index) => pr!==''?<p key={index}>{pr}</p>:'');

                        })()
                    }</div>
                    </div>
                    </>
                    }
                })
            }
        </>
    )
}

export default Proyecto;